/* eslint-disable no-undef */
import CUSTOM_PARAMETERS from "./CUSTOM_PARAMETERS";
import MDIGITAL_DECIBEL from "../integrations/decibel";
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_TARGETING from "./KAMPYLE_TARGETING";

  var QUARANTINE_DEFAULT_TEXTS = {
    DECLINED_DATE: 'The user did not decline',
    SUBMITTED_DATE: 'The user did not submit'
  };
  function init() {
    var eventMapping = {
      neb_targetingInit: [initTargeting],
      MDigital_manuallyInviteTargeting: [handleFormsTargeting],
      neb_initButton: [handleButton],
    };

    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);

    KAMPYLE_DATA.setMemoryData('targetingState', {});
  }

  //this function check if the user passed the cookie date
  function isDataValid(days, cookieName) {
    var checkingDate = Number(KAMPYLE_DATA.getData(cookieName));
    days = Number(days);
    if (!checkingDate || !days) {
      return false;
    }

    var msInOneDay = 1000 * 60 * 60 * 24;
    return (checkingDate + (msInOneDay * days)) > KAMPYLE_UTILS.getCurrentTimestamp();
  }

  //this function handle button
  function handleButton(eventName, data) {
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);

    if (!formData) {
      return false;
    }

    var kampyleDevice = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    if (kampyleDevice === KAMPYLE_CONSTANT.DEVICES.MOBILE || kampyleDevice === KAMPYLE_CONSTANT.DEVICES.TABLET) {
      if (KAMPYLE_FUNC.isPreloadConfigured()) {
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_LOAD_FORM, {formId: data.formId});
      }
    }
    KAMPYLE_DATA.setFormState(data.formId, {loaded: null});

    KAMPYLE_DATA.setMemoryData('buttonFormId', data.formId);
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_showButton', {formId: data.formId});

    KAMPYLE_DATA.setMemoryData('isButtonShown', true);
    return true;
  }

  function getTextByQuarentine(quarentineKey){
    if(KAMPYLE_DATA.getData(quarentineKey)){
      return new Date(parseInt(KAMPYLE_DATA.getData(quarentineKey)));
    }
    else{
      return QUARANTINE_DEFAULT_TEXTS[quarentineKey];
    }
  }

  // this function validate if invite should be shown
  function isShowInvite(formData) {
    KAMPYLE_UTILS.sendMessageToIframe('kampyleInvite', {
      action: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_VALIDATE_ORIGIN,
    }); // we need to send a message to validate if origin is valid before we show the invite

    var currentFormId = KAMPYLE_DATA.getMemoryData('currentInviteFormId');
    formData = formData || KAMPYLE_DATA.getFormData(currentFormId);
    if (!formData || KAMPYLE_DATA.getMemoryData('isInvitationShouldBeIgnored')) {
      return false;
    }
    var isSkipInvitation = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'inviteData.skipInvitation');
    
    // loop task array if all true -> showInvite
    var targetingState = KAMPYLE_DATA.getMemoryData('targetingState');
    for (var index in targetingState) {
      if (targetingState[index] !== true) {
        return false;
      }
    }

    var shouldDisableIntercept = KAMPYLE_TARGETING.shouldDisableIntercept(formData);

    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_BEHAVIORAL_TARGETING_PHASE_ENDED, formData);

    if (shouldDisableIntercept) {
      return false;
    }

    var isQuarantinePassed = isQuarantinePhasePassed(formData);

    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_QUARANTINED_SURVEY_PHASE_ENDED, formData);

    if(!isQuarantinePassed){
      return false;
    }
    
    KAMPYLE_DATA.setData('kampyleInvitePresented', true);

    KAMPYLE_UTILS.isTruthy(isSkipInvitation) ? handleSkippedInvitaion(formData) : KAMPYLE_TARGETING.handleNotSkippedInvitaion(formData);

    return true;
  }

  function isQuarantinePhasePassed(formData) {
    var isCheckQuarentinePassed = checkQuarantine(formData);
    var isFormIsShown = KAMPYLE_DATA.getMemoryData('formIsShown') === true;

    //if inviteOncePerSession == true =>> means that we can show invite more than once
    var isInviteMoreThanOncePerSession = KAMPYLE_UTILS.isTrue(KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.kampyleInvitePerSession.inviteOncePerSession'));

    var isInviteAlreadyShownInSession = !isInviteMoreThanOncePerSession && KAMPYLE_UTILS.isTrue(KAMPYLE_DATA.getData('kampyleInvitePresented'))

    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED, {
      formId: formData.formId,
      targetingRule: KAMPYLE_CONSTANT.TARGETING_RULES.INVITE_IF_ANY_INVITE_ALREADY_SHOWN_PER_SESSION,
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
      targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING,
      isPassed: !isInviteAlreadyShownInSession,
      expected: "Display Invite " + (isInviteMoreThanOncePerSession ? "more than once per session" : "once per session"),
      actual: !isInviteAlreadyShownInSession,
    });

    var isSurveySubmittedInSession = false
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXEMPT_FORMS_FROM_QUARANTINE)) {
      isSurveySubmittedInSession = !isInviteMoreThanOncePerSession && KAMPYLE_UTILS.isTrue(KAMPYLE_DATA.getData(KAMPYLE_CONSTANT.SESSION_DATA_FIELDS.IS_SURVEY_SUBMITTED_IN_SESSION))

      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED, {
        formId: formData.formId,
        targetingRule: KAMPYLE_CONSTANT.TARGETING_RULES.INVITE_IF_ANY_SURVEY_ALREADY_SUBMITTED_PER_SESSION,
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
        targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING,
        isPassed: !isSurveySubmittedInSession,
        expected: "Display Invite " + (isInviteMoreThanOncePerSession ? "more than once per session" : "once per session"),
        actual: !isSurveySubmittedInSession
      });
    }

    return (
      !isCheckQuarentinePassed &&
      !isFormIsShown &&
      !isInviteAlreadyShownInSession &&
      !isSurveySubmittedInSession
    )
  }

  function isUbtFailed(formData) {
    var isUbtCheckFailed = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING) &&
                           KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DO_NOT_SURVEY_ON_UBT_NETWORK_FAIL) &&
                           !KAMPYLE_DATA.getMemoryData('isGuest') &&
                           !KAMPYLE_DATA.getMemoryData('isSyncedIdentifierData');
    if (isUbtCheckFailed) {
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
        formId: formData.formId,
        targetingRule: 'ubtFailed',
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
        targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
        isPassed: !isUbtCheckFailed,
        expected: 'should ignore quarantine rules evaluation',
        actual: isUbtCheckFailed,
      });
    }
    return isUbtCheckFailed;
  }

  function handleSkippedInvitaion(formData) {
    if (!KAMPYLE_FUNC.isPreloadConfigured()) {
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_LOAD_FORM, {formId: formData.formId});
    }
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_skipInvitation', {formId: formData.formId});
  }

  function isAlreadySubmitted(formData) {
    var isAlreadySubmitted = isSubmitted(formData.onSiteData) === true;
    var submittedDays = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.submitted.days');
    var submittedDateText = KAMPYLE_TARGETING.getTextByQuarentine("SUBMITTED_DATE");
    submittedDays && KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
      formId: formData.formId,
      targetingRule: 'DontInviteOnSubmitted',
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
      targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING,
      isPassed: !isAlreadySubmitted,
      expected: submittedDays + " days",
      actual: "Current: " + new Date() + " Submitted: " + submittedDateText,
    });
    return isAlreadySubmitted;
  }

  function isAlreadyDeclined(formData) {
    var isAlreadyDeclined = isDeclined(formData.onSiteData) === true;
    var declinedDateText = KAMPYLE_TARGETING.getTextByQuarentine("DECLINED_DATE");
    var declinedDays = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.declined.days');
    declinedDays && KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
      formId: formData.formId,
      targetingRule: 'DontInviteOnDeclined',
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
      targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING,
      isPassed: !isAlreadyDeclined,
      expected: declinedDays + " days",
      actual: "Current: " + new Date() + " Declined: " + declinedDateText,
    });
    return isAlreadyDeclined;
  }

  function shouldDisableIntercept(formData) {
    var shouldDisableIntercept = false;
    var disableInterceptRule = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.disableInterceptRule');
    if (disableInterceptRule) {
      if (typeof disableInterceptRule === 'string') {
        disableInterceptRule = JSON.parse(disableInterceptRule);
      }
      shouldDisableIntercept = KAMPYLE_TARGETING.evaluateRule(disableInterceptRule, formData);

      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED, {
        formId: formData.formId,
        targetingRule: 'disableInterceptRule',
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
        targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
        isPassed: shouldDisableIntercept,
        expected: "Disable intercept rule should be true",
        actual: shouldDisableIntercept,
      });
    }
    return shouldDisableIntercept;
  }

  function handleNotSkippedInvitaion(formData) {
    if (KAMPYLE_DATA.getDisplayType(formData) === KAMPYLE_CONSTANT.DISPLAY_TYPES.POPUP) {
      KAMPYLE_DATA.setFormState(formData.formId, {inviteShown:true});
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_showInvitation', {formId: formData.formId });
    } else {
      if (KAMPYLE_FUNC.isFormLoaded(formData.formId)) {
        KAMPYLE_EVENT_DISPATCHER.trigger("neb_showInvitation", {formId: formData.formId});
      } else {
        KAMPYLE_DATA.setMemoryData(KAMPYLE_TARGETING.generateShouldShowInviteParamName(formData.formId), true);
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_LOAD_FORM, {formId: formData.formId}); // Replaced 'neb_showInvitation' to only show invitation after form is loaded
      }
    }
  }

  function initTargetingObject() {
    var targetingState = KAMPYLE_DATA.getMemoryData('targetingState');
    targetingState.kampyleTimeInSession = false;
    if (KAMPYLE_DATA.getMemoryData('kampyleDevice') === 'desktop') {
      targetingState.abandon = false;
    }
    targetingState.kampylePageElementEvent = false;
    targetingState.kampyleTimeOnPage = false;

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDecibelEnabled) {
      targetingState.decibelBehavioural = false;
      targetingState.decibelScore = false;
    }

    KAMPYLE_DATA.setMemoryData('targetingState', targetingState);
  }

  function validateCommonTargetingOnForm(form) {
    var canShow = true;

    var isUrlExcludedResult;
    if (canShow === true) {
      isUrlExcludedResult = isUrlExcluded(form);

      // Firing the event if there's actually a rule configured
      KAMPYLE_UTILS.getNestedPropertyValue(form, 'urlRules.exclusionUrl.rule') &&
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
          formId: form.formId,
          targetingRule: 'UrlExclude',
          formTriggerType: KAMPYLE_DATA.getFormTriggerType(form.formId),
          targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
          isPassed: !isUrlExcludedResult,
          expected: KAMPYLE_UTILS.getNestedPropertyValue(form, 'urlRules.exclusionUrl.rule'),
          actual: location.href,
      });
      if (isUrlExcludedResult === true){
          canShow = false;
      }
    }

    if(canShow === true){
        var isIncluded = isUrlIncluded(form);

        // Firing the event if there's actually a rule configured
        (KAMPYLE_UTILS.getNestedPropertyValue(form, 'urlRules.inclusionUrl.rule') &&
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
            formId: form.formId,
            formTriggerType: KAMPYLE_DATA.getFormTriggerType(form.formId),
            targetingRule: 'UrlInclude',
            targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
            isPassed: isIncluded,
            expected: KAMPYLE_UTILS.getNestedPropertyValue(form, 'urlRules.inclusionUrl.rule'),
            actual: location.href,
        }));
        if (isIncluded === false) {
            canShow = false;
        }
    }

    if (canShow === true) {
      var isGenericRuleValidResult = isGenericRuleValid(form);

      // Firing the event if there's actually a rule configured
      (KAMPYLE_UTILS.getNestedPropertyValue(form, 'onSiteData.genericRule') &&
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
          formId: form.formId,
          targetingRule: 'GenericRule',
          formTriggerType: KAMPYLE_DATA.getFormTriggerType(form.formId),
          targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
          isPassed: isGenericRuleValidResult,
          expected: "Generic rule evaluation result should be true",
          actual: isGenericRuleValidResult,
      }));
      canShow = isGenericRuleValidResult;
    }

    //check if targeting device found
    if (canShow === true) {
      canShow = targetingDevice(form);

      // Firing the event if there's actually a rule configured
      (KAMPYLE_UTILS.getNestedPropertyValue(form, 'onSiteData.devicetypes') &&
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED, {
          formId: form.formId,
          targetingRule: 'DeviceTypes',
          formTriggerType: KAMPYLE_DATA.getFormTriggerType(form.formId),
          targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
          isPassed: canShow,
          expected: KAMPYLE_UTILS.getNestedPropertyValue(form, 'onSiteData.devicetypes').toString(),
          actual: KAMPYLE_DATA.getMemoryData('kampyleDevice'),
      }));
    }

    return canShow;
  }

  function isGenericRuleValid(data) {
    //check if set exclude
    if (data && data.onSiteData && data.onSiteData.genericRule) {

      //Server returns a string
      if (typeof data.onSiteData.genericRule === 'string') {
        if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.GREATER_SMALLER_THAN_DECODE)){
          data.onSiteData.genericRule = KAMPYLE_UTILS.htmlDecode(data.onSiteData.genericRule);
        }
        data.onSiteData.genericRule = JSON.parse(data.onSiteData.genericRule);
      }
      return KAMPYLE_TARGETING.evaluateRule(data.onSiteData.genericRule, data);
    }
    return true;
  }

  // Check if url match rule url
  function isUrlMatch(urlToMatch) {
    if (!(typeof urlToMatch === 'string')) {
      return false;
    }

    if (urlToMatch === '') {
      return false;
    }
    urlToMatch = urlToMatch.replace(/%3B/g,';');
    urlToMatch = urlToMatch.toLowerCase();
    var currentUrl = document.location.href.toLowerCase();
    /* first check if the all url ( with domain ) is suitable */
    var matchUrl = currentUrl.substring(0, urlToMatch.length);
    if (matchUrl === urlToMatch) {
      return true;
    }
    else {
      // drop the domain from the url
      currentUrl = currentUrl.replace(/^(?:https?:\/\/)?(?:www\.)?([^\/]+)/i, '');
      matchUrl = currentUrl.substring(0, urlToMatch.length);
      if (matchUrl === urlToMatch) {
        return true;
      }
    }
    return false;
  }

  //this function checks if the cureent domain is in the urls data
  function isUrlLimits(urlsData) {
    //split the data
    urlsData = urlsData.split(';');
    var length = urlsData.length;
    for (var i = 0; i < length; i++) {
      var res = isUrlMatch(urlsData[i]);
      if (res === true) {
        return true;
      }
    }
    return false;
  }

  //this function check if the current domain is in the excluded urls
  function isUrlExcluded(data) {
    //check if set exclude
    if (!!data.urlRules && !!data.urlRules.exclusionUrl) {
      //check if the string is empty ,if so put '/'
      if (!!data.urlRules.exclusionUrl.rule) {
        var isExcluded = isUrlLimits(data.urlRules.exclusionUrl.rule);
        //if the url is not in the excluded urls
        return isExcluded;
      }
    }

    return false;
  }

  //this function check if the current domain is in the excluded urls
  function isUrlIncluded(data) {
    //check if set exclude
    if (!!data.urlRules && !!data.urlRules.inclusionUrl) {
      //check if the string is empty ,if so put '/'
      if (!!data.urlRules.inclusionUrl.rule) {
        var isIncluded = isUrlLimits(data.urlRules.inclusionUrl.rule);
        //if url in the included urls
        return isIncluded;
      }
    }
    return true;
  }

  function checkAllowedOperator(paramType, operator) {
    var paramTypeToOperator = {
      'text': [ KAMPYLE_CONSTANT.OPERATORS.EQUALS, KAMPYLE_CONSTANT.OPERATORS.DOES_NOT_EQUAL, KAMPYLE_CONSTANT.OPERATORS.CONTAINS,
        KAMPYLE_CONSTANT.OPERATORS.DOES_NOT_CONTAIN, KAMPYLE_CONSTANT.OPERATORS.STARTS_WITH, KAMPYLE_CONSTANT.OPERATORS.ENDS_WITH,
        KAMPYLE_CONSTANT.OPERATORS.HAS_VALUE, KAMPYLE_CONSTANT.OPERATORS.REGEX],
      'boolean': [KAMPYLE_CONSTANT.OPERATORS.EQUALS, KAMPYLE_CONSTANT.OPERATORS.HAS_VALUE],
      'datetime': [KAMPYLE_CONSTANT.OPERATORS.EQUALS, KAMPYLE_CONSTANT.OPERATORS.DOES_NOT_EQUAL, KAMPYLE_CONSTANT.OPERATORS.LATER_THAN,
        KAMPYLE_CONSTANT.OPERATORS.EARLIER_THAN, KAMPYLE_CONSTANT.OPERATORS.HAS_VALUE],
      'number': [KAMPYLE_CONSTANT.OPERATORS.EQUALS, KAMPYLE_CONSTANT.OPERATORS.DOES_NOT_EQUAL, KAMPYLE_CONSTANT.OPERATORS.GREATER_THAN,
        KAMPYLE_CONSTANT.OPERATORS.SMALLER_THAN, KAMPYLE_CONSTANT.OPERATORS.HAS_VALUE]
    };
    paramType = KAMPYLE_UTILS.safeToLower(paramType);
    operator = KAMPYLE_UTILS.safeToLower(operator);
    if (!paramType || !operator ||
      !paramTypeToOperator[paramType] ||
      paramTypeToOperator[paramType].indexOf(operator) === -1) {
      return false;
    }
    else {
      return true;
    }
  }

  function evaluateCriteria(criteria, formData) {
    var evaluation = false;
    var paramValue;
    var secondParamValue;
    var isAllowedOperator;

    if (!criteria) {
      return false;
    }

    var allowedTypes = ['customParam'];

    var condition = KAMPYLE_UTILS.safeToLower(criteria.condition);

    if (!criteria || criteria.value === undefined || criteria.value === null ||
      allowedTypes.indexOf(criteria.fieldOrigin) === -1) {
      evaluation = false;
    }
    else {
      switch (criteria.fieldOrigin) {
        case 'customParam':

          var customParamObj = CUSTOM_PARAMETERS.getCustomParamById(criteria.fieldId, formData);
          if (customParamObj && customParamObj.source_name) {
            paramValue = CUSTOM_PARAMETERS.getCustomParamValue({
              type: customParamObj.type,
              name: customParamObj.source_name,
              source: customParamObj.source
            });
            secondParamValue = CUSTOM_PARAMETERS.getCustomParamValue({
              type: customParamObj.type,
              name: customParamObj.source_name,
              source: customParamObj.source,
              value: criteria.value
            });
            isAllowedOperator = checkAllowedOperator(customParamObj.type, criteria.condition);
          }

          //Check this type of custom param is allowed this operator
          if (paramValue !== undefined && isAllowedOperator) {
            evaluation = KAMPYLE_UTILS.kampyleCompareByOperator(paramValue, secondParamValue, condition, customParamObj.type);
          }
          break;
        default:
          break;
      }
    }
    return evaluation;
  }

  function evaluateRule(toEvaluate, formData) {
    var tmpEval;
    var finalEval = false;
    var stopFlag = false;

    if (toEvaluate && toEvaluate.type === 'criteriaGroup' &&
      toEvaluate.childrenCriterias && toEvaluate.childrenCriterias.length &&
      toEvaluate.conjunction) {

      for (var i = 0; i < toEvaluate.childrenCriterias.length && !stopFlag; i++) {
        tmpEval = KAMPYLE_TARGETING.evaluateRule(toEvaluate.childrenCriterias[i], formData);

        if (tmpEval && toEvaluate.conjunction === 'OR') //GOOD Enough
        {
          finalEval = true;
          stopFlag = true;
        }
        else if (!tmpEval && toEvaluate.conjunction === 'AND') //One false in 'AND' is enough for false
        {
          finalEval = false;
          stopFlag = true;
        }
        else {
          finalEval = tmpEval;
        }
      }
    }
    else if (toEvaluate && toEvaluate.type === 'criteria') {
      finalEval = evaluateCriteria(toEvaluate, formData);
    }

    return finalEval;
  }

  function isNumSessions(data) {
    var kampyleUserSession = KAMPYLE_DATA.getData('kampyleUserSessionsCount');
    var numberOfVisitsResult = false;
    var numberOfRepeats = KAMPYLE_UTILS.getNestedPropertyValue(data, 'onSiteData.numberOfVisits.numberOfRepeats');
    var compareString = KAMPYLE_UTILS.getNestedPropertyValue(data, 'onSiteData.numberOfVisits.compareString');
    if (!!kampyleUserSession) {
      if (numberOfRepeats === null || compareString === null) {
        numberOfVisitsResult = true;
      }
      else {
        numberOfVisitsResult = KAMPYLE_UTILS.kampyleCompareByOperator(parseInt(kampyleUserSession), parseInt(numberOfRepeats), compareString);
      }
    }

    // Firing the event if there's actually a rule configured
    numberOfRepeats &&
    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
      formId: data.formId,
      targetingRule: 'NumberOfVisits',
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(data.formId),
      targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
      isPassed: numberOfVisitsResult,
      expected: compareString + ' ' + numberOfRepeats,
      actual: kampyleUserSession,
    });
    return numberOfVisitsResult;
  }

  function targetingDevice(data) {
    if (data && data.onSiteData && data.onSiteData.devicetypes) {
      var devicetypesLength = data.onSiteData.devicetypes.length;
      for (var i = 0; i < devicetypesLength; i++) {
        if (data.onSiteData.devicetypes[i] === KAMPYLE_DATA.getMemoryData('kampyleDevice')) {
          return true;
        }
      }
      return false;
    }

    return true;

  }

  function checkPagesInSession(sessionPageObj) {
    sessionPageObj = sessionPageObj || {};
    var pageCount = Number(KAMPYLE_DATA.getData('kampyleSessionPageCounter') || 0);
    return KAMPYLE_UTILS.kampyleCompareByOperator(pageCount, parseInt(sessionPageObj.numberOfRepeats), sessionPageObj.compareString);
  }
  function getDelayTimeByTabIndex(){
    var tabsIdentifiers = KAMPYLE_DATA.getStorageDataByPrefix(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.SESSION_TAB_PREFIX);
    tabsIdentifiers.sort(function(a, b){return Number(a)-Number(b)});
    var index = tabsIdentifiers.findIndex(function(item){ return Number(item) === KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.CURRENT_SESSION_TAB_ID )});
    if(index >= 0) {
      return (index + 1) * KAMPYLE_CONSTANT.DELAY_BETWEEN_TABS_TRIGGER_MS;
    }
    else {
      return null;
    } 
  }
  
  function onTimeInSessionEnds(){
    var timeToDelay = getDelayTimeByTabIndex();
    if(typeof timeToDelay === 'number'){
      setTimeout(function(){
        isShowInvite();
      }, timeToDelay);
    }
  }

  // Show the lightbox window when the user session is > N
  function timeInSession(time, formData) {
    // Check for user session timestamp
    validateGap(time, formData, true);
  }

  function getTimeInSession() {
    var kampyleUserSession = KAMPYLE_DATA.getData('kampyleUserSession');

    // compare time
    var kampyleUserSessionTimestamp = parseInt(kampyleUserSession);
    var diff = KAMPYLE_UTILS.getTimeDiff(kampyleUserSessionTimestamp);

    return diff;
  }

  // Check if the gap between session to current time
  function validateGap(time, formData, isFirstCall) {
    var requiredTimeInSession = parseInt(time) * 1000;
    var timeInSession = getTimeInSession();
    var targetingState = KAMPYLE_DATA.getMemoryData('targetingState');

    if (targetingState && timeInSession >= requiredTimeInSession) {

      targetingState.kampyleTimeInSession = true;
      KAMPYLE_DATA.setMemoryData('targetingState', targetingState);
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
        formId: formData.formId,
        targetingRule: 'TimeInSession',
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
        targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
        isPassed: true,
        expected: requiredTimeInSession,
        actual: "Over on the expected " + requiredTimeInSession,
      });
      if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.PARALLEL_TAB_SOLUTION)) {
        if(isFirstCall){
          KAMPYLE_TARGETING.isShowInvite();
         }
         else{
          KAMPYLE_TARGETING.onTimeInSessionEnds();
         }
      } else {
        KAMPYLE_TARGETING.isShowInvite();
      }
    }
    else {
      if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.PARALLEL_TAB_SOLUTION)) {
        if(isFirstCall){
          var currentTabId = Math.ceil(Math.random()*999999999999);
          KAMPYLE_DATA.setData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.SESSION_TAB_PREFIX+currentTabId, currentTabId);
          KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.CURRENT_SESSION_TAB_ID, currentTabId);
        }
      }
      var randomTime = 0;
      if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ADD_RANDOM_TIME_FOR_SESSION)) {
        var minValue  = 500;
        var maxValue = 9000;
        randomTime = KAMPYLE_UTILS.getRandomTimeMS(minValue,maxValue)
      }
      var diff = requiredTimeInSession - timeInSession;
      var thisObj = this;

      setTimeout(function () {
        validateGap(time, formData, false);
      }, diff + randomTime);
    }
  }

  //this function check if the decline set by the user is still valid for the specific form
  function isDeclined(data) {
    data = data || {};
    if (data.declined !== null && data.declined !== undefined) {
      var isStillDeclined = isDataValid(data.declined.days, 'DECLINED_DATE');
      return isStillDeclined;
    }
    return false;
  }

  //this function check if the accepted set by the user is still valid for the specific form
  function isSubmitted(data) {
    if (KAMPYLE_UTILS.getNestedPropertyValue(data, 'submitted')) {
      var isStillSubmitted = isDataValid(data.submitted.days, 'SUBMITTED_DATE');
      return isStillSubmitted;
    }

    return false;
  }

  function checkAbandon(formData) {
    // Show invite
    var isAbandonmentPassed = isUrlIncluded(formData) && !isUrlExcluded(formData);
    if(isAbandonmentPassed){
      KAMPYLE_DATA.setMemoryData('targetingState.abandon', true);
      if (isShowInvite() === false) {
        KAMPYLE_DATA.setMemoryData('targetingState.abandon', false);
      }
    }
    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
      formId: formData.formId,
      targetingRule: 'UserAbandonment',
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
      isPassed: isAbandonmentPassed,
      targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
      expected: "Mouse over user abandonment",
      actual: "Mouse was over user abandonment",
    });
  }

  /**
   *
   * @param abandonObj - {height:"1",zIndex:"1"}
   */
  function abandon(abandonObj, formData) {

    var zIndexDef = "0", heightDef = "5";
    if (!abandonObj) {
      abandonObj = {height: heightDef, zIndex: zIndexDef};
    }
    var zIndex = (!!abandonObj.zIndex) ? abandonObj.zIndex : zIndexDef;
    var height = (!!abandonObj.height && abandonObj.height !== "0") ? abandonObj.height + 'px' : heightDef + 'px';
    var abandon = document.getElementById('kampyle_abandon_zone');
    if (abandon === null) {
      var abandon = document.createElement('div');
      abandon.id = 'kampyle_abandon_zone';
      abandon.style.width = '100%';
      abandon.style.height = height;
      abandon.style.zIndex = zIndex;
      abandon.style.position = 'fixed';
      abandon.style.top = '0px';
      abandon.onmouseover = function () {
        checkAbandon(formData);
      };
      document.body.appendChild(abandon);
    }
    else {  //just need to change the high
      abandon.style.height = height;
      abandon.style.zIndex = zIndex;
    }
  }

  function getEventQuery(eventObj) {
    if (!eventObj || !eventObj.selectorValue || !eventObj.selectorType) {
      return null;
    }

    var query = '{{selector}}{{value}}';

    switch (eventObj.selectorType) {
      case 'className':
        query = query.replace('{{selector}}', '.');
        break;
      case 'objectId':
        query = query.replace('{{selector}}', '#');
        break;
      default:
        KAMPYLE_UTILS.showWarning('Invalid selector type:' + eventObj.selectorType);
        return null;
    }
    query = query.replace('{{value}}', eventObj.selectorValue);

    return query;
  }

  function handleTriggerByEvents(eventsObj, formData) {
    var queryString = getEventQuery(eventsObj);

    if (!queryString) {
      return null;
    }

    var delay = Number(eventsObj.time) || 0;
    var selectedElements = document.querySelectorAll(queryString) || [];

    for (var i = 0; i < selectedElements.length; i++) {

      var eventHandler = function () {
        var timeout = setTimeout(function () {
          KAMPYLE_DATA.setMemoryData('targetingState.kampylePageElementEvent', true);
          KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
            formId: formData.formId,
            targetingRule: 'PageElement',
            formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
            isPassed: true,
            targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
            expected: eventsObj.eventName + " for element with " + eventsObj.selectorType + "=" + eventsObj.selectorValue,
            actual: true,
          });
          if (isShowInvite() === false) {
            KAMPYLE_DATA.setMemoryData('targetingState.kampylePageElementEvent', false);
          }
          clearTimeout(timeout);
        }, delay * 1000);
        KAMPYLE_DATA.setTimeoutHandler('triggerByEventTimeout_' + i, timeout);
      }

      selectedElements[i].addEventListener(eventsObj.eventName, eventHandler);
      KAMPYLE_DATA.setDOMEventHandler('triggerByEvent_' + i, eventsObj.eventName, eventHandler, selectedElements[i]);
    }
  }

  // start checking the user time on page is > N seconds
  function sendTimeOnPageEventData (formData) {
    // Firing the event if there's actually a rule configured
    var timeOnPage = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.kampyleTimeOnPage.time');
    timeOnPage && KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
      formId: formData.formId,
      targetingRule: 'TimeOnPage',
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(formData.formId),
      isPassed: true,
      targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
      expected: timeOnPage,
      actual: "Over on the expecetd " + timeOnPage,
    });
  }

  function timeOnPage(time, formData) {
    if (time === null) {
      KAMPYLE_DATA.setMemoryData('targetingState.kampyleTimeOnPage', true);
      return;
    }

    var timeOnPageTimeOut = setTimeout(function () {
      KAMPYLE_DATA.setMemoryData('targetingState.kampyleTimeOnPage', true);
      sendTimeOnPageEventData(formData);
      isShowInvite();
    }, time * 1000);

    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_FIX_FOR_SPA_TIME_ON_PAGE)) {
      var timeOnPageTimeOutKey = "timeOnPage" + "_" + formData.formId;
      KAMPYLE_DATA.setTimeoutHandler(timeOnPageTimeOutKey, timeOnPageTimeOut);
    }

    KAMPYLE_DATA.setData('kampylePageLoadedTimestamp', KAMPYLE_UTILS.getCurrentTimestamp());
  }

  function setUserPercentile() {
    var percentile = Math.random() * 100; //now supporting two decimal digits percentage
    KAMPYLE_DATA.setData('kampyleUserPercentile', percentile);
    return percentile;
  }

  function getUserPercentile(formId) {
    var percentile = KAMPYLE_DATA.getData('kampyleUserPercentile');
    if (!percentile && percentile !== '0') //not in storage - need to draw number
    {
      percentile = KAMPYLE_TARGETING.setUserPercentile();
    }
    if(Number(percentile) && Number(percentile).toFixed){
      return Number(percentile).toFixed(1);
    }
    else{
      return Number(percentile);
    }
  }

  // Invite % users: 1-100
  function checkPercentageUsers(precUsersObj) {

    var userPercentile = getUserPercentile();

    // Random n users (1-100)
    if (!!precUsersObj && !!userPercentile) {
      var prec = Number(precUsersObj.prec);
      if (userPercentile > prec) {
        return false;
      }
    }

    return true;
  }

  // Get & execute the functions list
  function initDynamicTargeting(formData) {
    KAMPYLE_DATA.setMemoryData('isInviteActivated', true);
    var targetingState = KAMPYLE_DATA.getMemoryData('targetingState');

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDecibelEnabled) {
      var decibelBehavioural = formData.onSiteData.decibelBehavioural;
      if (decibelBehavioural) {
        MDIGITAL_DECIBEL.listenToBehaviouralEvent(decibelBehavioural.eventName, decibelBehavioural.time, isShowInvite, formData.formId);
      } else {
        targetingState.decibelBehavioural = true;
      }
      var decibelScore = formData.onSiteData.decibelScore;
      if (decibelScore) {
        MDIGITAL_DECIBEL.listenToScoreEvent(decibelScore.eventName, decibelScore.score, decibelScore.compareString, isShowInvite, formData.formId);
      } else {
        targetingState.decibelScore = true;
      }
    }

    if (formData.onSiteData.kampyleTimeInSession !== undefined) {
      timeInSession(formData.onSiteData.kampyleTimeInSession.time, formData);
    }
    else {
      targetingState.kampyleTimeInSession = true;
    }

    if (!!formData.onSiteData.abandon) {
      if (KAMPYLE_DATA.getMemoryData('kampyleDevice') === 'desktop') {
        abandon(formData.onSiteData.abandon, formData);
      }
    }
    else {
      targetingState.abandon = true;
    }

    var eventsContract = KAMPYLE_DATA.getTargetingData(formData.formId, 'pageEvents');
    if (eventsContract) {
      handleTriggerByEvents(eventsContract, formData);
    }
    else {
      targetingState.kampylePageElementEvent = true;
    }

    if (formData.onSiteData.kampyleTimeOnPage !== undefined) {
      timeOnPage(formData.onSiteData.kampyleTimeOnPage.time, formData);
    }
    else {
      targetingState.kampyleTimeOnPage = true;
    }

    //Update targeting state
    KAMPYLE_DATA.setMemoryData('targetingState', targetingState);

    /* check if the object is empty and if so show invite */
    for (var key in targetingState) {
      if (targetingState.hasOwnProperty(key) && !targetingState[key]) {
        return false;
      }
    }
    isShowInvite(formData);
  }

  //Targeting Phase I
  function initTargeting(eventName, data) {
    initTargetingMemoryData();
    initTargetingObject();
    handleFormsTargeting(eventName, data);
  }

  function initTargetingMemoryData() {
    KAMPYLE_DATA.setMemoryData('invitationTimeStamp', null);
    KAMPYLE_DATA.setMemoryData('buttonFormId', null);
    //TODO - remove formIsShown and use formState
    KAMPYLE_DATA.setMemoryData('formIsShown', false);
    KAMPYLE_DATA.setMemoryData('isButtonShown', false);
    KAMPYLE_DATA.setMemoryData('isInviteActivated', false);
    KAMPYLE_DATA.setMemoryData('targetingState', {});
  }


  function initEmbeddedTargeting() {
    var allForms = KAMPYLE_DATA.getAllForms();
    if (!allForms || !allForms.length) {
      return;
    }
    var canShow;
    for (var i = allForms.length - 1; i >= 0; i--) {
      var form = allForms[i];
      if (form.formType === KAMPYLE_CONSTANT.FORM_TYPES.EMBEDDED) {
        canShow = KAMPYLE_TARGETING.validateCommonTargetingOnForm(form);
        if (canShow) {
          var quarantineTargetingPassed = !KAMPYLE_TARGETING.checkQuarantine(form);
          var sessionTargetingPassed = KAMPYLE_TARGETING.validateCommonSessionTargeting(form.formId);
          var isUbtInitializedSuccessfully = !isUbtFailed(form);

          if( isUbtInitializedSuccessfully && quarantineTargetingPassed && sessionTargetingPassed ) {
            if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_AUTO_ADVANCE) ||
                KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_AUTO_SUBMIT)) {
              KAMPYLE_DATA.saveFormExtraData(form.formId, {
                triggerType: KAMPYLE_CONSTANT.FORM_TRIGGER_TYPES_MAP[form.formType],
              });
            }
            KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_LOAD_FORM, {formId: form.formId});
          }
        }
      }
    }
  }

  function initUserIdentifier() {
    var userIdentifierVal = null;
    if (!!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING)) {
      userIdentifierVal = KAMPYLE_FUNC.getUserIdentifierVal();
      var hasIdentifierValue = userIdentifierVal !== null;
      KAMPYLE_DATA.setMemoryData('isGuest', !hasIdentifierValue);
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_initUserIdentifier', {hasIdentifierValue: hasIdentifierValue});
    }
    return userIdentifierVal;
  }


  function handleIdentifierData(userIdentifierVal, eventName, data) {
    if (KAMPYLE_FUNC.shouldSyncIdentifier(userIdentifierVal)) { //sync server based targeting (SBT) data and call initFormsTargeting
      KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_settingIdentifierValueOnMemory', {hasIdentifierValue: userIdentifierVal !== null});
      KAMPYLE_DATA.setMemoryData('identifierValue', userIdentifierVal);
      KAMPYLE_FUNC.syncIdentifierData(encodeURIComponent(userIdentifierVal), initFormsTargeting.bind(this, arguments[0], arguments[1]));
    } else { //initFormsTargeting without sync SBT
      KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_shouldNotSyncIdentifier');
      initFormsTargeting(eventName, data);
    }
  }

  function handleFormsTargeting(eventName, data) {
    var originalIdentifierValue = initUserIdentifier();

    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_UBT_IDENTIFIER_HASH)) {
      var userIdentifierDigest = KAMPYLE_UTILS.sha512(originalIdentifierValue);

      userIdentifierDigest.then(function(ubtVal) {
        handleIdentifierData(ubtVal, eventName, data)
      })
    } else {
      handleIdentifierData(originalIdentifierValue, eventName, data)
    }
  }

  function initFormsTargeting(eventName, data) {
    data = data || {};
    //check if there are forms in the json
    var allForms = KAMPYLE_DATA.getAllForms();
    if (!allForms || !allForms.length) {
      return;
    }
   
    KAMPYLE_TARGETING.initEmbeddedTargeting();
    var canShow;
    // go over all the forms in the json
    for (var i = allForms.length - 1; i >= 0; i--) {
      if (allForms[i].formType === KAMPYLE_CONSTANT.FORM_TYPES.BUTTON && !data.skipButtonTargeting && KAMPYLE_DATA.getMemoryData('isButtonShown') === false) {
        canShow = KAMPYLE_TARGETING.validateCommonTargetingOnForm(allForms[i]);
        if (canShow === true) {
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_initButton', {formId: allForms[i].formId});
        }
      }
      else if (KAMPYLE_TARGETING.shouldCheckInvite(allForms[i], data)) {
        canShow = KAMPYLE_TARGETING.validateCommonTargetingOnForm(allForms[i]) && KAMPYLE_TARGETING.validateCommonSessionTargeting(allForms[i].formId);
        if (canShow === true) {
          KAMPYLE_TARGETING.initDynamicTargeting(allForms[i]);
        }
      }
      if (KAMPYLE_DATA.getMemoryData('isInviteActivated') === true && KAMPYLE_DATA.getMemoryData('isButtonShown') === true) {
          break;
      }
    }

    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_PAGE_TARGETING_PHASE_ENDED);
  }

  function shouldCheckInvite(form, targetingSettings){
    return (
      form.formType === KAMPYLE_CONSTANT.FORM_TYPES.INVITATION &&
      !targetingSettings.skipInviteTargeting &&
      KAMPYLE_DATA.getMemoryData('isInviteActivated') === false &&
      !KAMPYLE_TARGETING.isUbtFailed(form) &&
      (KAMPYLE_UTILS.kampyleIsCookieEnabled() || !KAMPYLE_DATA.getPropertySharedSubdomain())
    )
  }

  function validateCommonSessionTargeting(formId){
    formId = formId || '';
    
    var data = KAMPYLE_DATA.getFormData(formId) || {};
    var isInvite = data.formType === KAMPYLE_CONSTANT.FORM_TYPES.INVITATION;
    if(isInvite){
      KAMPYLE_DATA.setMemoryData('currentInviteFormId', formId);
    }

    //check if number of sessions is valid
    if (KAMPYLE_TARGETING.isNumSessions(data) === false) {
      return false;
    }

      //check if % of users was set and valid
    if (KAMPYLE_UTILS.getNestedPropertyValue(data, 'onSiteData.kampyleInvitePercentageUsers.prec')) {
      var formPercentageUsersResult = checkPercentageUsers(data.onSiteData.kampyleInvitePercentageUsers);

      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED, {
        formId: data.formId,
        targetingRule: 'UsersPercentage',
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(data.formId),
        targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
        isPassed: formPercentageUsersResult,
        expected: KAMPYLE_UTILS.getNestedPropertyValue(data, 'onSiteData.kampyleInvitePercentageUsers.prec'),
        actual: getUserPercentile(),
      });

      if (formPercentageUsersResult === false) {
        return false;
      }
    }

      //Check if user has reached expected number of session page views
      //TODO - send data.onSiteData.NumberOfVisits as agrument in kampyleCheckPagesInSession and check
    var numberOfPagesResult = !!data.onSiteData.numberOfPagesViewed &&
        checkPagesInSession(data.onSiteData.numberOfPagesViewed) === false;

    // Firing the event if there's actually a rule configured
    (KAMPYLE_UTILS.getNestedPropertyValue(data,'onSiteData.numberOfPagesViewed.numberOfRepeats') &&
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
        formId: data.formId,
        targetingRule: 'NumberOfPagesViewed',
        targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING,
        isPassed: !numberOfPagesResult,
        expected: KAMPYLE_UTILS.getNestedPropertyValue(data,'onSiteData.numberOfPagesViewed.numberOfRepeats'),
        actual: KAMPYLE_DATA.getData('kampyleSessionPageCounter'),
      }));
    if (numberOfPagesResult) {
      return false;
    }

    /*if skip invite then preload the form if configured*/
    if(isInvite){
      if (KAMPYLE_UTILS.isTrue(data.inviteData.skipInvitation)) {
        if (KAMPYLE_FUNC.isPreloadConfigured()) {
          KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_LOAD_FORM, {formId: formId});
        }
      }
      else {
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadInvitation', {formId: formId});
      }
    }
    
    return true;
  }

  function setTargetingState(targetingName, isPassed) {
    KAMPYLE_DATA.setMemoryData('targetingState.' + targetingName, isPassed);
  }

  function generateShouldShowInviteParamName(formId) {
    if (!formId) {
      return null;
    }

    return 'shouldShowInvite' + '_' + formId;
  }

  function checkQuarantine(formData){
    var isDeclined = KAMPYLE_TARGETING.isAlreadyDeclined(formData);
    var isSubmitted = KAMPYLE_TARGETING.isAlreadySubmitted(formData);
    return isDeclined || isSubmitted;
  }

  export default {
    init: init,
    //For Testing
    initTargeting: initTargeting,
    initFormsTargeting: initFormsTargeting,
    validateCommonTargetingOnForm: validateCommonTargetingOnForm,
    isShowInvite: isShowInvite,
    handleButton: handleButton,
    isDataValid: isDataValid,
    generateShouldShowInviteParamName: generateShouldShowInviteParamName,
    handleNotSkippedInvitaion: handleNotSkippedInvitaion,
    initDynamicTargeting: initDynamicTargeting,
    validateCommonSessionTargeting: validateCommonSessionTargeting,
    isUbtFailed: isUbtFailed,
    evaluateRule: evaluateRule,
    shouldDisableIntercept: shouldDisableIntercept,
    checkPagesInSession: checkPagesInSession,
    isNumSessions: isNumSessions,
    targetingDevice: targetingDevice,
    setUserPercentile: setUserPercentile,
    getUserPercentile: getUserPercentile,
    checkPercentageUsers: checkPercentageUsers,
    validateGap: validateGap,
    getEventQuery: getEventQuery,
    handleTriggerByEvents: handleTriggerByEvents,
    isUrlMatch: isUrlMatch,
    onTimeInSessionEnds: onTimeInSessionEnds,
    getDelayTimeByTabIndex: getDelayTimeByTabIndex,
    setTargetingState: setTargetingState,
    getTextByQuarentine:getTextByQuarentine,
    shouldCheckInvite: shouldCheckInvite,
    isQuarantinePhasePassed:isQuarantinePhasePassed,
    isGenericRuleValid: isGenericRuleValid,
    checkQuarantine:checkQuarantine,
    initEmbeddedTargeting:initEmbeddedTargeting,
    isAlreadyDeclined:isAlreadyDeclined,
    isAlreadySubmitted:isAlreadySubmitted
  };